import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    customGrey: Palette['primary'];
  }

  interface PaletteOptions {
    customGrey?: PaletteOptions['primary'];
  }
}

export default createTheme({
  typography: {
    fontFamily: 'Open sans',
  },
  palette: {
    primary: {
      light: '#2879fb70',
      main: '#2779fb',
      dark: '#152744',
    },
    secondary: {
      light: '#E9E9E9',
      main: '#929292',
      dark: '#262626',
    },
    background: {
      default: '#ffffff',
      paper: '#F8F8F8',
    },
    error: {
      main: '#e9645f',
    },
    warning: {
      main: '#ffa726',
    },
    info: {
      main: '#2779fb',
    },
    success: {
      main: '#66bb6a',
    },
    text: {
      primary: '#262626',
      secondary: '#929292',
      disabled: '#C9C9C9',
    },
    common: {
      black: '#000000',
      white: '#ffffff',
    },
    customGrey: {
      light: '#F8F8F8',
      main: '#C9C9C9',
      dark: '#262626',
    },
  },
});
